// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /app-availability/get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeAppAvailabilityGetBody,
  typeAppAvailabilityGetOutput200,
} from "../../sdk/appAvailability/postAppAvailabilityGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildAppAvailabilityGetQueryKey(
  payload: typeAppAvailabilityGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  if (typeof payload.clientPlatform !== "undefined") {
    queryKeySegments.push(
      `clientPlatform:${JSON.stringify(payload.clientPlatform)}`,
    );
  }
  if (typeof payload.clientVersion !== "undefined") {
    queryKeySegments.push(
      `clientVersion:${JSON.stringify(payload.clientVersion)}`,
    );
  }
  return [
    "post:appAvailability:appAvailabilityGet",
    "svc:site-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeAppAvailabilityGetOutput200,
    unknown,
    typeAppAvailabilityGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useAppAvailabilityGet(
  payload: typeAppAvailabilityGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildAppAvailabilityGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postAppAvailabilityGet(payload),
    ...resolvedOptions,
  });
}
